import {
  ACTION_GET_USER_TRAVEL_POLICY_RULES,
  ACTION_GET_USER_TRAVEL_POLICY_RULES_SUCCESS,
  ACTION_GET_USER_TRAVEL_POLICY_RULES_FAILURE,
  ACTION_EMPTY_USER_TRAVEL_POLICY_RULES,
  ACTION_EMPTY_USER_TRAVEL_POLICY_SUCCESS_PROPERTY,
} from '../configs/ActionTypes';

const initialState = {
  userTravelPolicyRules: {
    budgetPolicy: {},
    policyRules: {
      flight: {},
      hotel: {},
      car: {},
    },
  },
  isLoading: false,
  success: null,
};

export default function (state = initialState, action: any) {
  switch (action.type) {
    case ACTION_GET_USER_TRAVEL_POLICY_RULES: {
      return {
        ...state,
        isLoading: true,
        success: null,
      };
    }

    case ACTION_GET_USER_TRAVEL_POLICY_RULES_SUCCESS: {
      const {
        payload: { payload },
      } = action || {};

      return {
        ...state,
        userTravelPolicyRules: payload,
        isLoading: false,
        success: true,
      };
    }

    case ACTION_GET_USER_TRAVEL_POLICY_RULES_FAILURE: {
      return {
        ...state,
        userTravelPolicyRules: null,
        isLoading: false,
        success: true,
      };
    }

    case ACTION_EMPTY_USER_TRAVEL_POLICY_RULES: {
      return {
        ...state,
        userTravelPolicyRules: null,
        isLoading: false,
        success: false,
      };
    }

    case ACTION_EMPTY_USER_TRAVEL_POLICY_SUCCESS_PROPERTY: {
      return {
        ...state,
        success: null,
      };
    }

    default: {
      return state;
    }
  }
}
